<template>
  <v-row no-gutters>
    <v-col cols="12" sm="12">
      <v-form v-model="valid">
        <v-row no-gutters>
          <v-text-field
            v-model="annot"
            label="Keyword"
            :hint="annotHint"
            persistent-hint
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            v-model="alleleNumber"
            label="Minimum allele number"
            :rules="[rules.int]"
            persistent-hint
          ></v-text-field>
        </v-row>
      </v-form>
    </v-col>
    <v-row justify="space-around">
      <v-btn :disabled="!formIsValid" @click="searchLocus">Apply</v-btn>
      <v-btn @click="clearFilters">Clear</v-btn>
    </v-row>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      annot: '',
      annotHint: 'eg: kinase "transcription factor"',
      alleleNumber: '',
      rules: {
        int: v => {
          if (!v.trim()) return true;
          if (!isNaN(parseFloat(v)) && v >= 2) return true;
          return 'Number has to be higher than 2';
        },
      },
    };
  },
  computed: {
    formIsValid() {
      if (
        this.valid &&
        (this.annot.replace(/ /g, '') != '' || this.alleleNumber.replace(/ /g, '') != '')
      )
        return true;
      else return false;
    },
  },
  methods: {
    searchLocus() {
      this.$emit('searchAnnot', {
        keyword: this.annot.replace(/ /g, '%20'),
        minallelenb: this.alleleNumber,
      });
    },
    clearFilters() {
      this.annot = '';
      this.alleleNumber = '';
      this.$emit('clear');
    },
  },
};
</script>
